import { Component, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AssignmentParticipantsStateService } from '../../services/assignments-participants-state.service';
import { AssignmentParticipantSkillsModalComponent } from '../assignment-participant-skills-modal/assignment-participant-skills-modal.component';
import { AssignmentParticipantSkillsService } from '../../services/assignment-participant-skills.service';

@Component({
    selector: 'app-assignment-sportskills',
    templateUrl: './assignment-sportskills.component.html',
    styleUrl: './assignment-sportskills.component.scss'
})
export class AssignmentSportskillsComponent {
    @Input({ required: true }) assignmentId!: number;

    constructor(
        private modalRef: BsModalRef,
        private bsModalService: BsModalService,
        protected assignmenParticipantStateService: AssignmentParticipantsStateService,
        protected assignmenParticipantSkillsService: AssignmentParticipantSkillsService
    ) { }

    public openModal(): void {
        this.bsModalService.show(AssignmentParticipantSkillsModalComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            initialState: {
                assignmentId: this.assignmentId
            }
        });
    }
}
